/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'

const Icon = ({ theme, color }) => <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd' d='M5.65942 3.97966C5.65942 3.59306 5.97282 3.27966 6.35942 3.27966H9.55942C9.94602 3.27966 10.2594 3.59306 10.2594 3.97966V4.97974H5.65942V3.97966ZM4.65942 4.97974V3.97966C4.65942 3.04078 5.42054 2.27966 6.35942 2.27966H9.55942C10.4983 2.27966 11.2594 3.04078 11.2594 3.97966V4.97974H12.7431C13.682 4.97974 14.4431 5.74085 14.4431 6.67974V13.0797C14.4431 14.0186 13.682 14.7797 12.7431 14.7797H3.14311C2.20423 14.7797 1.44312 14.0186 1.44312 13.0797V6.67974C1.44312 5.74085 2.20423 4.97974 3.14312 4.97974H4.65942ZM2.44312 6.67974C2.44312 6.29314 2.75652 5.97974 3.14312 5.97974H12.7431C13.1297 5.97974 13.4431 6.29314 13.4431 6.67974V13.0797C13.4431 13.4663 13.1297 13.7797 12.7431 13.7797H3.14311C2.75652 13.7797 2.44312 13.4663 2.44312 13.0797V6.67974Z'
      fill={theme.colors[color]}/>
</svg>

Icon.propTypes = {
    theme: PropTypes.object,
    color: PropTypes.string,
}

export default withTheme(Icon)
